import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import './ZoomControl.css';

const ZoomControl: React.FC = () => {
    const map = useMap();
    const controlRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (controlRef.current) {
            // Utiliser l'API Leaflet pour désactiver complètement les événements
            L.DomEvent.disableClickPropagation(controlRef.current);
            L.DomEvent.disableScrollPropagation(controlRef.current);
        }
    }, []);

    const handleZoomIn = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        map.zoomIn();
    };

    const handleZoomOut = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        map.zoomOut();
    };

    const handleButtonMouseDown = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const handleButtonMouseUp = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div
            ref={controlRef}
            className="custom-zoom-control"
        >
            <button
                className="zoom-button zoom-in"
                onClick={handleZoomIn}
                onMouseDown={handleButtonMouseDown}
                onMouseUp={handleButtonMouseUp}
                title="Zoom avant"
                type="button"
            >
                <span className="zoom-icon">+</span>
            </button>
            <button
                className="zoom-button zoom-out"
                onClick={handleZoomOut}
                onMouseDown={handleButtonMouseDown}
                onMouseUp={handleButtonMouseUp}
                title="Zoom arrière"
                type="button"
            >
                <span className="zoom-icon">−</span>
            </button>
        </div>
    );
};

export default ZoomControl;
